/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Promo_BodyInputs */

const ja_playdata_home_promo_body = /** @type {(inputs: Playdata_Home_Promo_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2025年版レポート公開！`)
};

const en_playdata_home_promo_body = /** @type {(inputs: Playdata_Home_Promo_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2025 Report Now Available!`)
};

/**
* | output |
* | --- |
* | "2025 Report Now Available!" |
*
* @param {Playdata_Home_Promo_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_promo_body = /** @type {((inputs?: Playdata_Home_Promo_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Promo_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_promo_body(inputs)
	return en_playdata_home_promo_body(inputs)
});